import { errorValidation, maskList, geoIpLookup } from './utils';

/**
 * Validate forms
 */
function initializeCreditValidation(creditPhone, country_code) {
	/**
	 * Init intlTelInput
	 */
	if (creditPhone.length) {
		$(window).on('load', function () {
			let phones_exist = false;
			[creditPhone].forEach(phoneInput => {
				var phoneValue = phoneInput.val();
				if (phoneValue) {
					phones_exist = true;
					setTimeout(function () {
						phoneInput.val(phoneValue);
					}, 500);
				}
			});

			if (!phones_exist) {
				setTimeout(function () {
					// geoIpLookup(countryCode => {
					// 	[creditPhone].forEach(phoneInput => {
					// 		phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
					// 		const maskObj = maskList.find(mask => {
					// 			return (
					// 				mask.cc &&
					// 				typeof mask.cc === 'string' &&
					// 				mask.cc.toLowerCase() === countryCode.toLowerCase()
					// 			);
					// 		});
					// 		if (maskObj) {
					// 			console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
					// 			phoneInput.inputmask('remove');
					// 			phoneInput.inputmask({ mask: maskObj.mask });
					// 		}
					// 	});
					// });
				}, 500);
			}
		});

		[creditPhone].forEach(phoneInput => {
			phoneInput.intlTelInput({
				initialCountry: 'auto', // Automatically detect the country
				placeholderNumberType: 'aggressive',
				utilsScript:
					'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
				separateDialCode: false,
				allowDropdown: false,
			});

			phoneInput.inputmasks({
				inputmask: {
					definitions: {
						'#': {
							validator: '[0-9]',
							cardinality: 1,
						},
					},
					//clearIncomplete: false,
					showMaskOnHover: false, // Show mask
					autoUnmask: true, // Remove country code when input is empty
				},
				match: /[0-9]/,
				replace: '#',
				list: maskList,
				listKey: 'mask',
				onMaskChange: function (maskObj, completed) {
					if (maskObj) {
						// console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
						// let countryCode = Array.isArray(maskObj.cc)
						// 	? maskObj.cc[0].toLowerCase()
						// 	: maskObj.cc.toLowerCase();
						// phoneInput.intlTelInput('setCountry', countryCode);
						phoneInput.intlTelInput('setCountry', country_code.toLowerCase());
					} else {
						console.log(`No mask found, applying default mask`);
						phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
					}
				},
			});

			// On blur: validate phone number
			phoneInput.focusout(function () {
				if ($.trim(phoneInput.val())) {
					if (phoneInput.intlTelInput('isValidNumber')) {
						console.log('isValidNumber');
					} else {
						phoneInput.addClass('_error');
					}
				}
			});

			// On keydown: reset
			phoneInput.keydown(function () {
				phoneInput.removeClass('_error');
			});
		});
	}

	/**
	 * Add custom validation method
	 */
	$.validator.addMethod(
		'validateCreditPhone',
		function (value, element) {
			return $(element).intlTelInput('isValidNumber');
		},
		window.translations.phoneInvalid
	);

	// Credit
	$("form[name='credit']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'credit[name]': {
				required: true,
			},
			'credit[email]': {
				required: true,
				email: true,
			},
			'credit[phone]': {
				required: true,
				validateCreditPhone: true,
			},
		},
		messages: {
			'credit[name]': {
				required: window.translations.required,
			},
			'credit[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'credit[phone]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
}

$(document).on('click', '.get_credit', function (e) {
	e.preventDefault();
	const _self = $(this);
	let product = _self.closest('.product__box');
	let id = product.data('id');
	let image = product.attr('data-image');
	let color_id = _self.attr('data-color_id');
	let dimension_id = _self.attr('data-dimension_id');
	let modification_id = _self.attr('data-modification_id');

	addLoader('.credit__loader', 3000, {}, function () {
		$.ajax({
			url: '/' + lang + '/ajax/get_credit', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				id: id,
				image: image,
				color_id: color_id,
				dimension_id: dimension_id,
			},
			success: function (data) {
				console.log('data: ', data);
				if (data.status == 'ok') {
					$('.header__credit').remove();
					$('.wrapper').append(data.view);

					let creditPhone = $('#credit_phone');
					let country_code = $('form[name="credit"]').data('country_code');

					initializeCreditValidation(creditPhone, country_code);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
});

$(document).on('click', '#create_order_credit', function (event) {
	event.preventDefault();
	let credit_form = $("form[name='credit']");
	if (credit_form.valid()) {
		let credit = credit_form.serializeArray();

		let allData = {};
		$.each(credit, function (index, field) {
			allData[field.name] = field.value;
		});

		console.log('allData: ', allData);

		$.ajax({
			url: '/' + lang + '/ajax/order_credit', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: allData,
			success: function (data) {
				if (data.status == 'ok') {
					console.log('data: ', data);
				} else {
					location.reload();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
});
